import { Routes } from '@angular/router';
import { LabUnprocessedComponent } from './unprocessed/unprocessed.component';
import { LabComponent } from './lab.component';
import { LabProcessedComponent } from './processed/processed.component';
import { LabLibraryComponent } from './library/library.component';
import { AuthenticationGuard } from '../authentication/authentication.guard';

export const labRoutes: Routes = [
  { path: '', component: LabComponent, canActivate: [AuthenticationGuard], children: [
    { path: '', pathMatch: 'full', redirectTo: 'unprocessed' },
    { path: 'unprocessed', component: LabUnprocessedComponent },
    { path: 'processed', component: LabProcessedComponent },
    { path: 'library', component: LabLibraryComponent },
  ]}
];
